// React
import React, {Fragment, useState, useEffect} from "react";
import { useSelector, useDispatch } from "react-redux";
import {capitalize } from '../../utils/utils'; //isEven
import {
    serverMensaje,
    // fetchBenefSociosData,
    fetchBenefGolfData,
    // setListReservas,
    insertBatchListaReservasGolf
} from '../../redux/reducers/cumpli';

// import DatePicker from 'calcite-react/DatePicker';
import moment from 'moment';
import 'moment/locale/es-us';
import * as XLSX from 'xlsx';
import Progress from 'calcite-react/Progress';
import { Formik, Field } from "formik"; //Form
import Form, {
    FormControl,
    FormControlLabel,
    FormHelperText,
    // Fieldset,
    // Legend
  } from 'calcite-react/Form';

import Table, {
    TableHeader,
    TableHeaderRow,
    TableHeaderCell,
    TableBody,
    TableRow,
    TableCell
} from 'calcite-react/Table';

import {showMsgToaster} from '../ShowMesg';
import {ToastContainer} from 'calcite-react/Toaster'; //notify
import Alert, {AlertMessage} from 'calcite-react/Alert';
import Switch from 'calcite-react/Switch';
import Select from 'calcite-react/Select';
import {MenuItem} from 'calcite-react/Menu';
import Button from 'calcite-react/Button';
import FileUploader from 'calcite-react/FileUploader';

import SaveIcon from 'calcite-ui-icons-react/SaveIcon';
import UploadIcon from 'calcite-ui-icons-react/UploadIcon';


// // Styled & Motion Components
import styled from "styled-components";

const LoadReservasExcel = styled.div`
    position: relative;
    max-width: auto;
    border: 1px solid #ccc;
    background-color: #fff;
    padding: 10px;
    margin: 4px 6px;

    /* Extra large devices (large laptops and desktops, 1200px and up) */
    @media only screen and (max-width: 1200px) {
        
    } 

    /* Large devices (laptops/desktops, 992px and up) */
    @media only screen and (max-width: 992px) {
        
    }

    /* Medium devices (landscape tablets, 768px and up) */
    @media only screen and (max-width: 768px) {
        max-width: 450px;
    }

    /* Small devices (portrait tablets and large phones, 600px and up) */
    @media only screen and (max-width: 600px) {
        max-width: 450px;
    }

    /* Extra small devices (phones, 600px and down) */
    @media only screen and (max-width: 600px) {
        max-width: 450px;
    }

`;

const TablaReservasExcel = styled.div`
    background: #fff;
    overflow: auto;

    /* Extra large devices (large laptops and desktops, 1200px and up) */
    @media only screen and (max-width: 1200px) {
        
    } 

    /* Large devices (laptops/desktops, 992px and up) */
    @media only screen and (max-width: 992px) {
        
    }

    /* Medium devices (landscape tablets, 768px and up) */
    @media only screen and (max-width: 768px) {

    }

    /* Small devices (portrait tablets and large phones, 600px and up) */
    @media only screen and (max-width: 600px) {
        max-width: 450px;
        max-height: 250px;
    }

    /* Extra small devices (phones, 600px and down) */
    @media only screen and (max-width: 600px) {
        max-width: 450px;
        max-height: 250px;
    }

`;

const ModuleReservas = props => {
    const users = useSelector(state => state.users);
    // const isEditable = users.user.tipo==='ADMINISTRADOR' ? true : false;
    const mensaje = useSelector(state => state.cumpli.mensaje);
    const [error, setError] = useState(null);
    const listGolf = useSelector(state => state.cumpli.listGolf);
    // const listSocios = useSelector(state => state.cumpli.listSocios);
    const [listTodos,setListTodos] = useState([]);
    // Sin pico y cédula de nuevo - Ago 29
    // const [listImpares,setListImpares] = useState([]);
    // const [listPares,setListPares] = useState([]);
    const [listReservasOriginal,setListReservasOriginal] = useState([]);
    const [listReservasJSON, setListReservasJSON] = useState({});
    const [asignacionAuto, setAsignacionAuto] = useState(false);
    const [caddiexplayer, setCaddiexplayer] = useState(false);
    const [isEditable, setIsEditable] = useState(false);
    const [isListLoaded, setIsListLoaded] = useState(false);
    const [isListCedulasPar, ] = useState(true); //setIsListCedulasPar
    let diaservicio = new Date();
    diaservicio.setDate(diaservicio.getDate() + 1);// add a day
    const [picoycedula, ] = useState(diaservicio.getDate()); //setPicoycedula
    // const [progressReservasValue, setProgressReservasValue] = useState(0.0);
    const reserva = { archivo: null, }
    const dispatch = useDispatch();
    
    // useEffect(() => {
    //     dispatch(fetchBenefSociosData({token: users.user.claveAPI}));
    // }, [users.user.claveAPI, dispatch]);

    useEffect(() => {
        if (!listGolf || listGolf.length<=0)
            dispatch(fetchBenefGolfData({token: users.user.claveAPI}));
    }, [users.user.claveAPI, listGolf, dispatch]);

    useEffect(() => {
        if (listGolf && listGolf.length > 0){
            let todosPI = [' '];
            // Pico y Cédula Cambio de neuvo Ago 29
            // let pares = [' '];
            // let impares = [' '];
            // Seleccionar Beneficiarios de acuerdo al pico y cédula
            for (let idx = 0; idx < listGolf.length; idx++) {
                const b = listGolf[idx];
                // const cedula = b.docId; //cedula.charAt(cedula.length-1)
                // Seleccione solamente los que pueden prestar el servicio
                if (b.prestarservicio==='1'){
                    const nombre = capitalize(b.nombres + ' ' + b.apellidos,true) + ' - ['+b.categoria+']';
                    // Pico y Cédula Cambio de neuvo Ago 29
                    // const isPar = isEven(parseInt(b.docId.slice(-1))); 
                    // console.log("Pico y Cédula:", cedula, (isPar ? 'Par' : 'Impar'));
                    // (isPar) ?  pares.push(nombre) : impares.push(nombre);
                    todosPI.push(nombre)
                }
                
            }
            // Pico y Cédula Cambio de neuvo Ago 29
            // setListPares(pares);
            // setListImpares(impares);
            // // Revisar pico y cédula del día sgte y asignar como restricción inicial
            // setIsListCedulasPar(isEven(parseInt(picoycedula)));
            // Asignar todos los caddies disponibles
            setListTodos(todosPI);
        }

        if (mensaje.listareservas && mensaje.listareservas!=='') {
            document.getElementById("progressBar-Reservas").style.display = 'none';
            if (typeof mensaje.listareservas === 'string' && mensaje.listareservas.toLowerCase().includes('error')){
                showMsgToaster('error', 'Ocurrió un fallo en el servidor', mensaje.listareservas);
            } else {
                // showMsgToaster('success',"Lista de Reservas", mensaje.listareservas); //"🧭 " + mensaje
                showMsgToaster('success', 'Reservas', 'Lista de Reserva guardada con exito!');
                mensaje.listareservas='';
                dispatch(serverMensaje({listareservas:''}));
            }
        }

    }, [listGolf, picoycedula, mensaje.listareservas, dispatch]);

    const onSubmit = (values, actions) => {
        const f = values.archivo[0];
        // Validate whether File is valid Excel file.
        // var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.xls|.xlsx)$/;
        var regex_xls = /^([a-zA-Z0-9\s_\\.\-:])+(.xls)$/;
        // Solamente evalue .xls en formato viejo o extraño de la app de Reservas del Club (html)
        if (regex_xls.test(f.name.toLowerCase())) {
            // console.log('Formato viejo');
            if (typeof (FileReader) != "undefined") {
                const reader = new FileReader();
                reader.onload = (evt) => { // evt = on_file_select event
                    /* Parse data */
                    try{
                        const arraybuffer = evt.target.result;
                        let datatxt = (JSON.stringify(arraybuffer));
                        // Estos datos del xls vienen planos en ascii y representan un HTML mal formado
                        // Por tanto se extrae la información que se necesita que es a partir del tag TABLE
                        let htmlstr = datatxt.toString().split('<body>')[1];
                        htmlstr = htmlstr.replace(/Ã‘/g,'Ñ').replace(/Ãâ/g,'Ñ').replace(/\\n\\t/g,'').replace(/\\n/g,'').replace(/\\t/g,'');
                        // console.log(htmlstr);
                        /* Convert array of arrays */
                        // var htmlstr = "<table width='100%' border='1'><tr><th colspan='6'>Se encontraron 10 registro(s) </th></tr><tr><th>SERVICIO</th><th>NUMERO ACCION</th><th>TIPO SOCIO</th><th>SOCIO</th><th>USUARIO</th><th>BENEFICIARIO</th><th>BOLEADOR</th><th>TEE</th><th>MODALIDAD</th><th>TIPO RESERVA</th><th>PAX</th><th>ELEMENTO</th><th>FECHA CREACION RESERVA</th><th>FECHA RESERVA</th><th>HORA</th><th>INVITADOS</th><th>OBSERVACIONES</th><th>CREADA POR</th><th>COMENTARIO STARTER</th><th>CUMPLIDA SOCIO</th><th>USUARIO QUE AGREGO COMO CUMPLIDA S/N</th><th>FECHA SE MARCO COMO CUMPLIDA S/N </th><th>TIPO PAGO</th><th>CODIGO</th><th>ESTADO TRANSACCION</th><th>MEDIO PAGO</th><th>PAGO CONFIRMADO</th><th>VALOR PAGADO</th><th>CANCHA</th><th>EQUIPO</th><th>IP</th><th>CONSECUTIVO</th></tr><tr><td>Golf</td><td>0413</td><td>Beneficiario</td><td>EDUARDO MADRIÃâAN MICOLTA</td><td>14943799</td><td> </td><td></td><td>TEE1</td><td></td><td></td><td>0</td><td>CAMPO 9 HOYOS</td><td>2020-07-27 08:19:53</td><td>2020-07-28</td><td>06:30:00</td><td></td><td></td><td>Socio</td><td></td><td></td><td></td><td>0000-00-00 00:00:00</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td>190.99.198.213</td><td>-0</td></tr><tr><td>Golf</td><td>0413</td><td>Beneficiario</td><td>YOLANDA OLANO RODRIGUEZ</td><td>31212806</td><td> </td><td></td><td>TEE1</td><td></td><td></td><td>0</td><td>CAMPO 9 HOYOS</td><td>2020-07-27 08:23:25</td><td>2020-07-28</td><td>06:45:00</td><td></td><td></td><td>Socio</td><td></td><td></td><td></td><td>0000-00-00 00:00:00</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td>190.99.198.213</td><td>-0</td></tr><tr><td>Golf</td><td>0118</td><td>Socio</td><td>HENRY POSADA TORRES</td><td>19220711</td><td> </td><td></td><td>TEE1</td><td></td><td></td><td>0</td><td>CAMPO 9 HOYOS</td><td>2020-07-27 08:30:07</td><td>2020-07-28</td><td>07:00:00</td><td></td><td></td><td>Socio</td><td></td><td></td><td></td><td>0000-00-00 00:00:00</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td>191.156.46.207</td><td>-0</td></tr><tr><td>Golf</td><td>0705</td><td>Socio</td><td>JUAN CARLOS MEJIA MILLAN</td><td>16801508</td><td> </td><td></td><td>TEE1</td><td></td><td></td><td>0</td><td>CAMPO 9 HOYOS</td><td>2020-07-27 08:06:55</td><td>2020-07-28</td><td>07:15:00</td><td></td><td></td><td>Socio</td><td></td><td></td><td></td><td>0000-00-00 00:00:00</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td>181.59.154.174</td><td>-0</td></tr><tr><td>Golf</td><td>0089</td><td>Socio</td><td>MARCO POLO GOMEZ GIRALDO</td><td>3607835</td><td> </td><td></td><td>TEE1</td><td></td><td></td><td>0</td><td>CAMPO 9 HOYOS</td><td>2020-07-27 12:53:47</td><td>2020-07-28</td><td>07:30:00</td><td></td><td></td><td>Socio</td><td></td><td></td><td></td><td>0000-00-00 00:00:00</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td>191.106.149.229</td><td>-0</td></tr><tr><td>Golf</td><td>0225</td><td>Socio</td><td>LUIS FERNANDO BARONA GUTIERREZ BARONA GUTIERREZ</td><td>16620144</td><td> </td><td></td><td>TEE1</td><td></td><td></td><td>0</td><td>CAMPO 9 HOYOS</td><td>2020-07-27 11:22:51</td><td>2020-07-28</td><td>08:00:00</td><td></td><td></td><td>Socio</td><td></td><td></td><td></td><td>0000-00-00 00:00:00</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td>191.102.199.7</td><td>-0</td></tr><tr><td>Golf</td><td>0319</td><td>Socio</td><td>ALFONSO PEREZ CORRAL</td><td>16580429</td><td> </td><td></td><td>TEE1</td><td></td><td></td><td>0</td><td>CAMPO 9 HOYOS</td><td>2020-07-27 11:12:59</td><td>2020-07-28</td><td>08:30:00</td><td>Socio: ALVARO REINA PINO<br> Socio: ALFONSO REINA VELEZ<br> </td><td></td><td>Socio</td><td></td><td></td><td></td><td>0000-00-00 00:00:00</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td>200.116.195.226</td><td>-0</td></tr><tr><td>Golf</td><td>0071</td><td>Socio</td><td>JORGE ANDRES IRURITA GUTIERREZ</td><td>1006034166</td><td> </td><td></td><td>TEE1</td><td></td><td></td><td>0</td><td>CAMPO 9 HOYOS</td><td>2020-07-27 15:12:56</td><td>2020-07-28</td><td>10:00:00</td><td></td><td></td><td>Socio</td><td></td><td></td><td></td><td>0000-00-00 00:00:00</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td>191.156.36.245</td><td>-0</td></tr><tr><td>Golf</td><td>0104</td><td>Socio</td><td>IVAN ALEJANDRO RODRIGUEZ CORDOBA</td><td>91491735</td><td> </td><td></td><td>TEE1</td><td></td><td></td><td>0</td><td>CAMPO 9 HOYOS</td><td>2020-07-27 12:38:33</td><td>2020-07-28</td><td>10:15:00</td><td>Socio: DIEGO OSORIO MARTINEZ<br> </td><td></td><td>Socio</td><td></td><td></td><td></td><td>0000-00-00 00:00:00</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td>191.102.198.108</td><td>-0</td></tr><tr><td>Golf</td><td>0588</td><td>Socio</td><td>LUIS FERNANDO CASTRILLON RINCON</td><td>16685702</td><td> </td><td></td><td>TEE1</td><td></td><td></td><td>0</td><td>CAMPO 9 HOYOS</td><td>2020-07-27 07:44:42</td><td>2020-07-28</td><td>15:00:00</td><td></td><td></td><td>Socio</td><td></td><td></td><td></td><td>0000-00-00 00:00:00</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td>186.86.52.29</td><td>-0</td></tr></table>";
                        // Pasar todo como texto original para que no convierta erroneamente las fechas
                        const workbook = XLSX.read(htmlstr, {type:'string', cellDates:false, cellNF: false, cellText:true, raw: true}); //{type:'string', cellDates: false, cellText:false, dateNF: 'yyyy-mm-dd'}  //, sheetStubs: true
                        /* Get first worksheet */
                        const ws = workbook.Sheets[workbook.SheetNames[0]];
                        // const datajson = XLSX.utils.sheet_to_json(ws, {header:1, raw: false}); //{header:1, dateNF:'yyyy-mm-dd;@', cellDates:true, cellText:false, raw:true} //, defval: ""
                        const datajson = XLSX.utils.sheet_to_json(ws, {header:1, raw: true}); // Igual texto raw para que no convierta mal las fechas
                        // Removemos la cabecera y demas filas iniciales
                        // idx===0 // Se encontraron 19 registro(s)"
                        // idx===1 // header 32 columns
                        datajson.splice(0, 2);
                        /* Update state */
                        // console.log("Data JSON >>>",datajson);
                        setListReservasJSON(datajson);
                        setListReservasOriginal(datajson);
                        // Asignar Beneficiarios
                        asignarBeneficiarios(datajson, asignacionAuto, caddiexplayer, isListCedulasPar);
                        setIsListLoaded(true);
                    } catch(e){
                        console.log(e);
                    }
                };
                reader.readAsBinaryString(f);

            } else {
                setError("This browser does not support HTML5.");
            }
        } else {
            // console.log('Formato nuevo');
            if (typeof (FileReader) != "undefined") {
                const reader = new FileReader();
                reader.onload = (evt) => { // evt = on_file_select event
                    /* Parse data */
                    try {
                        const bstr = evt.target.result;
                        const wb = XLSX.read(bstr, {type:'binary'}); //, cellDates:true
                        /* Get first worksheet */
                        const wsname = wb.SheetNames[0];
                        const ws2 = wb.Sheets[wsname];
                        /* Convert array of arrays */
                        // const data = XLSX.utils.sheet_to_csv(ws, {header:1});
                        const datajson2 = XLSX.utils.sheet_to_json(ws2, {header:1, raw:false}); //, dateNF:"YYYY-MM-DD"
                        // Removemos la cabecera y demas filas iniciales
                        // idx===0 // Se encontraron 19 registro(s)"
                        // idx===1 // header 32 columns
                        datajson2.splice(0, 2);
                        /* Update state */
                        // console.log("Data JSON >>>",datajson2);
                        setListReservasJSON(datajson2);
                        setListReservasOriginal(datajson2);
                        // Asignar Beneficiarios
                        asignarBeneficiarios(datajson2, asignacionAuto, caddiexplayer, isListCedulasPar);
                        setIsListLoaded(true);
                        // document.getElementById('tablaReservas').innerHTML = datahtml;
                    } catch(e){
                        console.log(e);
                    }
                };
                reader.readAsBinaryString(f);

            } else {
                setError("This browser does not support HTML5.");
            }
        }
        actions.setSubmitting(false);
        setIsEditable(true);
        
    }

    const onValidate = values => {
        const errors = {}
        if (values.archivo===null) {
            errors.archivo = 'Por favor seleccione un archivo primero'
        }
        if (values.archivo && values.archivo.length) {
            if (values.archivo[0].size > 1000000) {
                errors.archivo = 'Por favor escoja una archivo menor de 1000kb.'
            }
        }
        // Validate whether File is valid Excel file.
        var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.xls|.xlsx|.xlsm)$/;
        if (!regex.test(values.archivo[0].name.toLowerCase())) {
            errors.archivo = 'Por favor escoja una archivo (.xls, .xlsx, .xlsm) válido'
        }

        if (errors.archivo===null || errors.archivo===undefined) {
            setIsEditable(true);
            // setIsListLoaded(true);
        } else {
            setIsEditable(false);
            setIsListLoaded(false);
        }

        return errors
    }

    const onBtnAceptar = () =>{
        document.getElementById("progressBar-Reservas").style.display = 'block';
        if (listReservasJSON && listReservasJSON.length > 0 ){
            // Organizar Lista final
            let listReservas = [];
            listReservasJSON.forEach((itm,idx) => {
                let benef = {}; //itm[5]; //eg. 'Julián Alberto Ararat Astudillo - [3]'
                if (itm[5]){
                    const bfiltro = [...listGolf].filter(b => (b.nombres + ' ' + b.apellidos+ ' - ['+b.categoria+']').toLowerCase() === itm[5].toLowerCase() );
                    // console.log(benef, itm[5].toLowerCase());
                    if (bfiltro && bfiltro.length>0){
                        benef = bfiltro[0];
                    }
                }
                const reserva = {
                    "beneficiarioId": benef.docId || '',
                    "beneficiario": benef.nombres ? capitalize(benef.nombres + ' ' + benef.apellidos, true) : '', //itm[5] || "",
                    "categoria": benef.categoria || '',
                    "numaccion": itm[1] || '999999',
                    "tiposocio": itm[2] || '',
                    "socioId": itm[4] || '',
                    "socio": itm[3].toUpperCase(),
                    "fechareserva": moment(itm[13]+" "+itm[14]).format("YYYY-MM-DD HH:mm:ss"), //itm[13]+" "+itm[14],
                    "jugadores": itm[15] || "",
                    "cumplida": "0",
                    "campo": itm[11].replace('CAMPO ', '').toLowerCase() || "9 hoyos",
                    "comentarios": ""
                };
                listReservas.push(reserva);
            });
            // dispatch(setListReservas({listReservas: listReservas}));
            // Guardar Tabla de reservas
            dispatch(serverMensaje({listareservas:''}));
            dispatch(insertBatchListaReservasGolf({"token":users.user.claveAPI, "listareservas":listReservas}));
            
        } else {
            setError('Importe la lista de reservas antes de guardar...');
            document.getElementById("progressBar-Reservas").style.display = 'none';
        }
        
    }

    const clonarItem = (itm, jugador, socioname) =>{
        let newitm = [...itm];
        // // 0: "Golf"
        // newitm[1] = ''; //No. Acción // Modificar el itm directamente no actualiza la vista por que no hay un trigger asociado
        // newitm.slice(1, 1, '9999');
        newitm.splice(1, 1, '99999'); // Número de acción
        newitm.splice(2, 1, ''); //Tipo Socio o Jugador
        newitm.splice(4, 1, '99999'); //Documento del Jugador
        // newitm.splice(3, 1, jugadores ? jugadores[0] : ''); //Nombre del Jugador
        newitm.splice(3, 1, jugador); //Nombre del Jugador
        newitm.splice(15, 1, socioname); // newitm[15] = socioname; //Cambiamos por el nombre del Socio quién reservó
        
        // En un solo comando 
        // newitm = newitm.filter( ( _, i ) => i in newitm );
        newitm.forEach((e,idx) => {
            if (e===undefined) delete newitm[idx];
        });
        return newitm
    }

    // Función inhabilitada Ago 29
    // const onChangeListCedulasPar = (evt) =>{
    //     // evt.stopPropagation();
    //     setIsListCedulasPar(evt.target.checked); //isListCedulasPar
    //     // const beneficiarios = (evt.target.checked ? [...listPares] : [...listImpares]);
    //     asignarBeneficiarios(listReservasOriginal, asignacionAuto, caddiexplayer, evt.target.checked);
    // }

    const onChangeAsignacionAuto = (evt) =>{
        // evt.stopPropagation();
        setAsignacionAuto(evt.target.checked);
        asignarBeneficiarios(listReservasOriginal, evt.target.checked, caddiexplayer, isListCedulasPar);
    }

    const onChangeCaddiexPlayer = (evt) =>{
        // evt.stopPropagation();
        setCaddiexplayer(evt.target.checked);
        asignarBeneficiarios(listReservasOriginal, asignacionAuto, evt.target.checked, isListCedulasPar);
    }

    // const getBeneficiarios = () => {
    //     let benef = (isListCedulasPar ? [...listPares] : [...listImpares])
    //     console.log(benef);
    //     return benef
    // }

    const createNewList = (data, caddiexplayer) =>{
        let newLista = [];
        data.forEach((itm, idx) => {
            newLista.push(itm);
            // Asignar Caddies por Grupo o Individual
            if (caddiexplayer){
                // if (idx>1 && (itm[15] && itm[15]!=='')){ // old version
                if (itm[15] && itm[15]!==''){
                    let newitm = [...itm];
                    const socioname = 'Invitado por: ' + itm[3];
                    const jugadores = itm[15].split('\n'); //"Socio: ALVARO REINA PINO\nSocio: ALFONSO REINA VELEZ\n"
                    if (jugadores.length>0){
                        jugadores.forEach((jugador, ix) => {
                            if (jugador!==''){
                                newitm = clonarItem(newitm, jugador, socioname);
                                newLista.push(newitm);
                            }
                        });
                    } else {
                        const jugador = itm[15];
                        if (jugador!==''){
                            newitm = clonarItem(newitm, jugador, socioname);
                            newLista.push(newitm);
                        }
                    }
                }
            } 
           
        });
        return newLista
    }

    const reglasSeleccionCaddie = () => {
        let caddiesSel = [...listTodos]; // Lista de todos los caddies que pueden prestar el servicio
        // REGLAS
        // 1. Se cumplió una vuelta es necesario iniciar la lista de nuevo

        console.log(caddiesSel);

        // caddiesSel.map((nombre, idx) => {
           
        // });

        return caddiesSel
    }

    const asignarBeneficiarios = (data, asignacionAuto, caddiexplayer, isListCedulasPar) => {
        if (data && data.length > 0 ){
            // data === listReservasOriginal  solo contiene la cantidad posible de los caddies assignados en el dia
            // Iniciar lista con Beneficiarios asignados automaticamente y uno por grupo
            let newLista = [];
            let listaTemp = createNewList(data, caddiexplayer); // Crea lista de Socios
            // Cambio de reglas - Sin pico y cédula
            // let beneficiarios = (isListCedulasPar ? [...listPares] : [...listImpares]);
            let beneficiarios = reglasSeleccionCaddie(); //[...listTodos];
            if (listaTemp.length>beneficiarios.length){
                // showMsgToaster('info', 'Reservas', 'Lista de Reserva organizada para "Doble" cargada para '+listaTemp.length+' jugadores.');
                // console.log('Cantidad de Jugadores:',listaTemp.length);
                // console.log('Cantidad de Beneficiarios:',beneficiarios.length);
                // removemos el primer registro = [' '];
                beneficiarios.splice(0,1);
                beneficiarios = [...beneficiarios].concat(beneficiarios).concat(beneficiarios); // triplicar
                beneficiarios.splice(0,0,' ');
                // console.log('Cantidad de Beneficiarios disponibles para Doble:',beneficiarios.length);
            }
            listaTemp.forEach((itm, idx) => {
                if (asignacionAuto) {
                    // console.log(beneficiarios[idx]);
                    itm.splice(5, 1, beneficiarios[idx+1]);
                } else {
                    itm.splice(5, 1, '');
                }
                newLista.push(itm);
            });

            setListReservasJSON(newLista);
        }
        
    }

    const handleBenefSelectChange = (idx,value,item) => {
        listReservasJSON.map((itm, ix) => {
            if (ix===idx){
                itm.splice(5, 1, value);
            }
            return itm
        });
    };
    
    // 
    if (users)
        return (
        <Fragment>
            <ToastContainer />
            <LoadReservasExcel>
                <Formik initialValues={reserva} validate={onValidate} onSubmit={onSubmit}>
                    {({ values, errors, touched, handleSubmit, isSubmitting }) => (
                        <Form onSubmit={handleSubmit}>
                        {/* archivo */}
                        <FormControl style={{margin:'4px 0px 2px 0px'}}
                            success={touched.archivo && !errors.archivo ? true : false}
                            error={touched.archivo && errors.archivo ? true : false}
                        >
                            <FormControlLabel>Seleccionar archivo:</FormControlLabel>
                            {/* <Field component={FileUploader} name="archivo" accept="image/*" /> */}
                            <Field component={FileUploader} name="archivo" accept="*/*" />
                            <FormHelperText>
                                {(touched.archivo && errors.archivo) || null}
                            </FormHelperText>
                        </FormControl>
                        <FormControl style={{margin:'4px 0px 2px 0px'}}>
                            <Button type="submit" style={{margin:'20px 0px -4px'}}
                                iconPosition="before" 
                                icon={<UploadIcon size={16} />}
                                // disabled={!isEditable && isSubmitting ? true : false}
                                disabled={!isEditable}
                                // disabled={(touched.archivo && errors.archivo) ? true : false}
                            >
                            {/* {isSubmitting ? 'Cargando.......' : 'Cargar'} */}
                            Importar Reservas
                            </Button>
                        </FormControl>

                        </Form>
                    )}
                </Formik>
                
            </LoadReservasExcel>
            {/* Mostrar Algún Error */}
            {error && <div style={{color: 'red', width: '100%'}}>
                    <Alert red showIcon style={{minWidth: '100%', marginBottom: '10px'}}
                        showCloseLabel 
                        onClose={() => setError(null)}>
                        <AlertMessage>
                            Error:{' '}
                            <strong>{error}</strong>
                        </AlertMessage>
                    </Alert>
                </div> 
            }
            {/* <TablaReservasExcel id="tablaReservas" className="tbl-reservas-caddiemaster" /> */}
            <div id="optReservas" className="reservas-caddiemaster">
                <div className="optReservas-caddiemaster">
                        <Switch 
                            // labelPosition={"before"}
                            style={{margin: '0 0 0.2rem 0'}}
                            // name={ 'reservas_caddiexplayer'} 
                            checked={ caddiexplayer }
                            disabled={!isListLoaded} 
                            onChange={onChangeCaddiexPlayer}
                        >
                            Caddie por Jugador
                        </Switch>

                        <Switch 
                            style={{margin: '0 0 0.2rem 0'}}
                            // name={ 'reservas_asignacionauto'} 
                            checked={ asignacionAuto }
                            disabled={!isListLoaded} 
                            onChange={onChangeAsignacionAuto}
                        >
                            Asignación Automática
                        </Switch>
                        {/* Función inhabilitada Ago 29 */}
                        {/* <Switch 
                            style={{margin: '0 0 0.2rem 0'}}
                            // name={ 'reservas_picoycedula'} 
                            checked={ isListCedulasPar }
                            disabled={!isListLoaded} 
                            onChange={onChangeListCedulasPar}
                        >
                            { isListCedulasPar ? 'Pico y Cédula (Pares)' : 'Pico y Cédula (Impares)'}
                        </Switch> */}
                </div>
                
            </div>
            <TablaReservasExcel id="tbl-reservas" className="tbl-reservas-caddiemaster">
                <Table noCol>
                    <TableHeader>
                        <TableHeaderRow>
                            <TableHeaderCell style={{textAlign:'center'}}>NÚMERO ACCIÓN</TableHeaderCell>
                            {/* <TableHeaderCell style={{textAlign:'center'}}>TIPO SOCIO</TableHeaderCell> */}
                            <TableHeaderCell style={{textAlign:'center'}}>SOCIO</TableHeaderCell>
                            {/* <TableHeaderCell style={{textAlign:'center'}}>USUARIO</TableHeaderCell> */}
                            <TableHeaderCell style={{textAlign:'center'}}>BENEFICIARIO</TableHeaderCell>
                            <TableHeaderCell style={{textAlign:'center'}}>HORA</TableHeaderCell>
                            <TableHeaderCell style={{textAlign:'center'}}>FECHA RESERVA</TableHeaderCell>
                            <TableHeaderCell style={{textAlign:'center'}}>JUGADORES</TableHeaderCell>
                            <TableHeaderCell style={{textAlign:'center'}}>CAMPO</TableHeaderCell>
                            <TableHeaderCell style={{textAlign:'center'}}>FECHA CREACION RESERVA</TableHeaderCell>
                            {/* 
                            <TableHeaderCell style={{textAlign:'center'}}>BOLEADOR</TableHeaderCell>
                            <TableHeaderCell style={{textAlign:'center'}}>TEE</TableHeaderCell>
                            <TableHeaderCell style={{textAlign:'center'}}>MODALIDAD</TableHeaderCell>
                            <TableHeaderCell style={{textAlign:'center'}}>OBSERVACIONES</TableHeaderCell>
                            <TableHeaderCell style={{textAlign:'center'}}>CANCHA</TableHeaderCell>
                            <TableHeaderCell style={{textAlign:'center'}}>EQUIPO</TableHeaderCell> 
                            */}
                        </TableHeaderRow>
                    </TableHeader>
                    <TableBody>

                { listReservasJSON && listReservasJSON.length > 0 && 
                    listReservasJSON.map((itm, idx) => {
                        // console.log(idx, itm)
                        // idx===0 // Se encontraron 19 registro(s)"
                        // idx===1 // header 32 columns
                        // 0: "SERVICIO"
                        // 1: "NUMERO ACCION"
                        // 2: "TIPO SOCIO"
                        // 3: "SOCIO"
                        // 4: "USUARIO"
                        // 5: "BENEFICIARIO"
                        // 6: "BOLEADOR"
                        // 7: "TEE"
                        // 8: "MODALIDAD"
                        // 9: "TIPO RESERVA"
                        // 10: "PAX"
                        // 11: "ELEMENTO"
                        // 12: "FECHA CREACION RESERVA"
                        // 13: "FECHA RESERVA"
                        // 14: "HORA"
                        // 15: "INVITADOS"
                        // 16: "OBSERVACIONES"
                        // 17: "CREADA POR"
                        // 18: "COMENTARIO STARTER"
                        // 19: "CUMPLIDA SOCIO"
                        // 20: "USUARIO QUE AGREGO COMO CUMPLIDA S/N"
                        // 21: "FECHA SE MARCO COMO CUMPLIDA S/N"
                        // 22: "TIPO PAGO"
                        // 23: "CODIGO"
                        // 24: "ESTADO TRANSACCION"
                        // 25: "MEDIO PAGO"
                        // 26: "PAGO CONFIRMADO"
                        // 27: "VALOR PAGADO"
                        // 28: "CANCHA"
                        // 29: "EQUIPO"
                        // 30: "IP"
                        // 31: "CONSECUTIVO"
                        return (
                            // <div key={idx} className="itemContainer-Reservas">
                                // {
                                //   idx > 1 ? // old version
                                    itm[1] ?
                                        <TableRow key={idx}>
                                            <TableCell style={{maxWidth:'50px'}}>
                                                {itm[1] || ''} 
                                            </TableCell>
                                            {/* <TableCell style={{maxWidth:'150px'}}>
                                                {itm[2]}
                                            </TableCell> */}
                                            <TableCell style={{minWidth:'250px', fontWeight:500}}>
                                                {itm[3].toUpperCase()}
                                            </TableCell>
                                            {/* <TableCell style={{maxWidth:'150px'}}>
                                                {itm[4]}
                                            </TableCell> */}
                                            <TableCell style={{minWidth:'230px', fontWeight:600}}>
                                                {/* {itm[5]} */}
                                                <Select minimal filterable positionFixed
                                                    onChange={(value,item) => handleBenefSelectChange(idx,value,item)}
                                                    selectedValue={asignacionAuto ? (itm[5]!=='' ? itm[5] : ' ') : ' ' }
                                                    >
                                                    {   
                                                        listTodos.map((nombre, idx) => {
                                                            return (
                                                            <MenuItem key={idx+'_'+nombre} value={nombre}>
                                                                {nombre}
                                                            </MenuItem>
                                                            )
                                                        })
                                                        // Cambio de reglas de nuevo Ago 29 - No Pico y Cédula
                                                        // isListCedulasPar ? 
                                                        //     listPares.map((nombre, idx) => {
                                                        //         return (
                                                        //         <MenuItem key={idx+'_'+nombre} value={nombre}>
                                                        //             {nombre}
                                                        //         </MenuItem>
                                                        //         )
                                                        //     })
                                                        // : 
                                                        //     listImpares.map((nombre, idx) => {
                                                        //         return (
                                                        //         <MenuItem key={idx+'_'+nombre} value={nombre}>
                                                        //             {nombre}
                                                        //         </MenuItem>
                                                        //         )
                                                        //     })
                                                    }

                                                    
                                                </Select>
                                            </TableCell>
                                            <TableCell style={{maxWidth:'150px', fontWeight:600}}>
                                                {itm[14]}
                                            </TableCell>
                                            <TableCell style={{maxWidth:'150px'}}>
                                                {itm[13]}
                                            </TableCell>
                                            <TableCell style={{minWidth:'300px'}}>
                                                {itm[15]}
                                            </TableCell>
                                            <TableCell style={{maxWidth:'220px'}}>
                                                {itm[11].replace('CAMPO ', '')}
                                            </TableCell>
                                            <TableCell style={{maxWidth:'150px'}}>
                                                {itm[12]}
                                            </TableCell>
                                        </TableRow>
                                    : <TableRow key={idx} style={{display:'none'}}></TableRow>
                                 
                        )
                    })
                }
                </TableBody>
                </Table>
            </TablaReservasExcel>
                <div id="progressBar-Reservas" className="reservas-caddiemaster-progress">
                    <Progress type="indeterminate" />
                </div>
                <div style={{textAlign:'center'}}>
                    <Button iconPosition="before" 
                        disabled={!isListLoaded}
                        onClick={onBtnAceptar}
                        icon={<SaveIcon size={16} />}
                    >
                        Guardar Lista Reservas
                    </Button>
                </div>

        </Fragment>
    );

return (<></>)
}
  
export default ModuleReservas;